function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = debounce;

function getSectionDOM(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector);
}
window.getSectionDOM = getSectionDOM;

function getSectionInnerHTML(html, selector) {
  return getSectionDOM(html, selector).innerHTML;
}
window.getSectionInnerHTML = getSectionInnerHTML;

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": `application/${type}` }
  };
}
window.fetchConfig = fetchConfig;

// prevent page not scrolling to section (contact form)
function scrollToSection(id) {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
}
window.scrollToSection = scrollToSection;
window.addEventListener("load", () => {
  const hash = window.location.hash;
  if (hash) {
    scrollToSection(hash.slice(1));
  }
});